import { render, staticRenderFns } from "./AgentFansItem.vue?vue&type=template&id=6806bb16&"
import script from "./AgentFansItem.vue?vue&type=script&lang=js&"
export * from "./AgentFansItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentFansItem.vue?vue&type=style&index=0&id=6806bb16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports